import React from "react"
import { Banner, Button, TextTag as Text } from "../../atoms"
import { connect } from "react-redux"
import {
  PARTNER_INVITED_HEADING,
  PARTENR_INVITED_SUB_HEADING,
  REJECT_BUTTON,
  ACCEPT_BUTTON,
  INTERVAL_TIME,
} from "../../constants/messages"
import _ from "../../utils/lodashUtils"
import "./AcceptOrRejectInvite.scss"
import {
  secretCodeVerification,
  rejectInvite,
} from "../../redux/actionCreators/invitePeople"
import { emailVerification, getUserData } from "../../redux/actionCreators/auth"
import {
  resendEmailVerificationLink,
  resendVerificationButton,
  verifyEmailMessage,
} from "../../constants/validationMessages"
import { useInterval } from "common-custom-hooks"
import {
  FirebaseContext,
  FIREBASE_STATE_KEYS,
  FirebaseService,
} from "../../firebase"
import {
  getPartnerNameorNickName,
  formatPhoneNumber,
  getGenderSpecificMessage,
} from "../../utils/helpers"
import { ActivityIndicator } from "../ActivityIndicator"

const AcceptOrRejectInvite = (props) => {
  const {
    secretCodeVerification,
    myPartner,
    partners,
    rejectInvite,
    acceptingInvite,
    rejectingInvite,
    user,
  } = props
  const { partnerState } = React.useContext(FirebaseContext)
  const signUpMethod = _.get(user, "signup_method")
  const isEmailVerified = _.get(user, "email_verification_status")
  const partnerName = getPartnerNameorNickName(
    partnerState,
    myPartner,
    partners
  )
  const acceptInvite = () => {
    secretCodeVerification({
      secretCode: _.get(myPartner, "invite_code"),
    })
  }
  const gender = getGenderSpecificMessage(
    _.get(partnerState, "userDetails.gender", _.get(myPartner, "gender"))
  )

  const resendEmail = async () => {
    //send email to verify the primary signup
    const token = localStorage.getItem("token")
    await props.emailVerification(token)
  }

  useInterval(() => {
    //get user data continuously from backend till emailverified falg is true to update banner accordingly.
    if (signUpMethod === "EMAIL" && !isEmailVerified) {
      props.getUserData(props.user.id)
    }
  }, INTERVAL_TIME)

  const handleReject = async () => {
    //update our backend when user rejects the invite
    rejectInvite()
    //update firebase with rejected status
    FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.REJECTED_BY]: user.uuid,
      },
      `${FirebaseService.getDefaultPath()}`
    )
    //send user to invite screen
    FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.ACTIVE_ROUTE]: "/dashboard",
      },
      `${FirebaseService.getDefaultPath()}${myPartner.uuid}/`
    )
  }

  let userName = _.get(myPartner, "username")

  if (_.get(myPartner, "signup_method") === "PHONE") {
    const formattedPhoneNumber = formatPhoneNumber(userName)

    userName =
      formattedPhoneNumber && formattedPhoneNumber.intlCode
        ? `${formattedPhoneNumber.intlCode} ${formattedPhoneNumber.telephoneNumber}`
        : userName
  }

  return (
    <div id="AcceptOrRejectInvite">
      {signUpMethod === "EMAIL" && !isEmailVerified ? (
        <Banner type="secondary">
          <div className="resendEmailContainer">
            <div className="emailText">
              <Text textType="sectionHeading">{verifyEmailMessage}</Text>
              <Text textType="sectionTextPrimary" className="verify_email">
                {resendEmailVerificationLink}
              </Text>
            </div>
            <Button className="resendEmailButton" onClick={resendEmail}>
              {resendVerificationButton}
            </Button>
          </div>
        </Banner>
      ) : null}
      <div className="heading">
        <Text textType="spaceName">{PARTNER_INVITED_HEADING(partnerName)}</Text>
      </div>
      <div className="subheading">
        <Text textType="sectionHeading">
          {PARTENR_INVITED_SUB_HEADING(partnerName, userName, gender)}
        </Text>
      </div>
      <div className="btns-box">
        <Button
          className="accept"
          btnType="primary"
          btnSize="large"
          onClick={acceptInvite}
          disabled={
            (signUpMethod === "EMAIL" && !isEmailVerified) || acceptingInvite
          }
        >
          {acceptingInvite && <ActivityIndicator />}
          {ACCEPT_BUTTON}
        </Button>
        <Button
          className="reject"
          btnType="colorBorder"
          btnSize="large"
          onClick={handleReject}
          disabled={
            (signUpMethod === "EMAIL" && !isEmailVerified) || rejectingInvite
          }
        >
          {rejectingInvite && <ActivityIndicator />}
          {REJECT_BUTTON}
        </Button>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  partners: state.invitePeople.partnerDetails,
  myPartner: _.get(state, "auth.partner", {}),
  acceptingInvite: _.get(state, "loadingState.acceptingInvite"),
  rejectingInvite: _.get(state, "loadingState.rejectingInvite"),
})

export default connect(mapStateToProps, {
  secretCodeVerification,
  rejectInvite,
  emailVerification,
  getUserData,
})(AcceptOrRejectInvite)
